export const SELL_SEATING_PREFERENCE = 'SellSeatingPreference';
export const SELL_SEATING_BESIDE = 'SellSeatingBeside';
export const SELL_SEAT_MAP_SEGMENT_NEW = 'SellSeatMapSegmentNew';
export const SELL_SEAT_MAP_SEGMENT = 'SellSeatMapSegment';
export const SELL_SEAT_MAP_NO_OPTION = 'NO_OPTION';
export const AISLE = 'AISLE';
export const WINDOW = 'WINDOW';
export const BESIDE = 'BESIDE';
export const NO_OPTION = 'NO_OPTION';
export const SEATING_PREFERENCE_OPTIONS = {
  SELL_SEATING_PREFERENCE,
  SELL_SEATING_BESIDE,
  SELL_SEAT_MAP_SEGMENT_NEW,
  SELL_SEAT_MAP_SEGMENT
};
export const SEATING_PREFERENCE_VALUES = {
  AISLE,
  WINDOW,
  BESIDE,
  NO_OPTION
};
//# sourceMappingURL=constants.js.map